import {
    IAffiliate,
    IBrand,
    ICountry,
    IMedia,
    IMessage,
    IRequest,
    IRequestFile,
    IRequestStatus,
    ITheme,
    ITypeOfAssets,
    ITypeOfCampaign,
    IUser,
    Priority
} from "@/models";
import { v1 as uuid } from "uuid";

export class Request implements IRequest {
    public static fromRequest(source: IRequest, target: IRequest) {
        if (source !== null && source !== undefined) {
            target = target ?? new Request();
            target = { ...source };
            target.countries = source.countries?.map(c => ({ ...c })) ?? [];
            target.media = source.media?.map(m => ({ ...m })) ?? [];
            target.messages = source.messages?.map(m => ({ ...m })) ?? [];
            target.themes = source.themes?.map(t => ({ ...t })) ?? [];
        }

        return target;
    }

    public requestId: number = 0;
    public advice: boolean = false;
    public affiliate: IAffiliate = null;
    public archive: boolean = null;
    public brand: IBrand = null;
    public campaignDescription: string = "";
    public campaignName: string = "";
    public countries: ICountry[] = [];
    public createdBy: IUser = null;
    public createdDate: Date = null;
    public creatorPhotoBase64 = null;
    public decisionDeadline: Date = null;
    public decisionDescription: string = "";
    public deleted: boolean = null;
    public files: IRequestFile[] = [];
    public key: string = uuid();
    public typeOfCampaign: ITypeOfCampaign = null;
    public typeOfAssets: ITypeOfAssets = null;
    public media: IMedia[] = [];
    public messages: IMessage[] = [];
    public numberOfAssets: number = 0;
    public priority?: Priority = null;
    public requestStatus: IRequestStatus = {
        name: "",
        step: 0,
        requestStatusId: 0,
        value: "",
    };
    public responsibleDrinking: boolean = false;
    public submittedBy: IUser = null;
    public submittedDate: Date = null;
    public sustainabilityClaim: boolean = false;
    public nonAlcoholicProduct: boolean = false;
    public rtd: boolean = false;
    public aiGeneratedContent: boolean = false;
    public updatedBy: IUser = null;
    public updatedDate: Date = null;
    public validatedBy: IUser = null;
    public validatedDate: Date = null;
    public watchers: IUser[] = [];
    public themes: ITheme[] = [];
}
